import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {TareaDiaria} from '../../shared/model/tarea/tareaDiaria.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Constantes} from '../../utilerias/constantes/constantes';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import { DatePipe, NgIf } from '@angular/common';
import {UtileriasService} from '../../utilerias/service/utilerias.service';
import {UrlConstantes} from '../../utilerias/constantes/urlconstantes';
import {GenericoService} from '../../shared/services/generico.service';
import {ProgramacionTarea} from '../../shared/model/tarea/programacionTarea.model';
import swal from 'sweetalert2';
import {SweetAlertComponent} from '../../shared/SweetMesssage';
import { firstValueFrom, Observable, timer} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatFormField, MatInput, MatHint, MatError } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

const horasPausaFormControl = 'horasPausaFormControl';
const minutosPausaFormControl = 'minutosPausaFormControl';
const inicioPausaFormControl = 'inicioPausaFormControl';
const minutosTareaFormControl = 'minutosTareaFormControl';
const horasTareaFormControl = 'horasTareaFormControl';

@Component({
    selector: 'app-tarea-tiempo',
    standalone: true,
    templateUrl: './tarea-tiempo.component.html',
    styleUrls: ['./tarea-tiempo.component.css'],
    imports: [FormsModule, MatCheckbox, MatIcon, MatTooltip, MatFormField, ReactiveFormsModule, MatInput, MatHint, NgIf, MatError, MatButton, DatePipe]
})
export class TareaTiempoComponent implements OnInit {


    formGroup: FormGroup;
    matcher = new ErrorStateMatcher();
    tarea = new TareaDiaria();
    esPausaConsiderada: boolean;
    programacionTarea: ProgramacionTarea = new ProgramacionTarea();

    relojObservable: Observable<Date>;
    relojInicioTarea: Date;
    relojFinTarea: Date;

    constructor(public dialogRef: MatDialogRef<TareaTiempoComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
                private datePipe: DatePipe, private formBuilder: FormBuilder, private service: GenericoService,
                private sweetAlert: SweetAlertComponent, private utils: UtileriasService) {
        this.relojObservable = timer(0, 1000).pipe(map(() => new Date()), shareReplay(1));
    }

    ngOnInit() {
        this.tarea = this.data;
        this.iniciarFormulario();
        this.iniciarValores();
        this.esPausaConsiderada = false;
        this.considerarPausa();
        this.iniciarReloj();
    }

    private iniciarReloj() {
        this.relojObservable.subscribe(reloj => {
            this.relojInicioTarea = reloj;
            const horasTarea = this.formGroup.get(horasTareaFormControl).value * 1000 * 60 * 60;
            const minutosTarea = this.formGroup.get(minutosTareaFormControl).value * 1000 * 60;
            let horasPausa = 0;
            let minutosPausa = 0;
            if (this.esPausaConsiderada) {
                horasPausa = this.formGroup.get(horasPausaFormControl).value * 1000 * 60 * 60;
                minutosPausa = this.formGroup.get(minutosPausaFormControl).value * 1000 * 60;
            }
            const tiempoTarea = horasTarea + minutosTarea + horasPausa + minutosPausa;
            this.relojFinTarea = new Date( reloj.getTime() + tiempoTarea);
        });
    }

    private iniciarFormulario() {
        this.formGroup = this.formBuilder.group({
            horasTareaFormControl: new FormControl(Constantes.VACIO, [
                Validators.required,
                Validators.min(0),
                Validators.max(11)
            ]),

            minutosTareaFormControl: new FormControl(Constantes.VACIO, [
                Validators.required,
                Validators.min(0),
                Validators.max(59)
            ]),

            inicioPausaFormControl: new FormControl(Constantes.VACIO, [
                Validators.required
            ]),

            horasPausaFormControl: new FormControl(Constantes.VACIO, [
                Validators.required,
                Validators.min(0),
                Validators.max(4)
            ]),

            minutosPausaFormControl: new FormControl('', [
                Validators.required,
                Validators.min(0),
                Validators.max(59)
            ])
        });
    }

    private iniciarValores() {
        this.formGroup.get(horasTareaFormControl).setValue(Constantes.OCHO);
        this.agregarCerosInicialesMinutosTarea();

        const inicioPausa = new Date();
        inicioPausa.setHours(Constantes.CATORCE);
        inicioPausa.setMinutes(Constantes.CERO);
        this.formGroup.get(inicioPausaFormControl).setValue( this.datePipe.transform(inicioPausa, Constantes.FORMATO_HORA_MINUTOS) );

        this.formGroup.get(horasPausaFormControl).setValue(Constantes.DOS);
        this.agregarCerosInicialesMinutosPausa();
    }

    agregarCerosInicialesMinutosTarea() {
        const numero: string = this.formGroup.get(minutosTareaFormControl).value;
        if (numero == null) { return; }
        if (Number(numero) >= 10) {
            this.formGroup.get(minutosTareaFormControl).setValue( Number(numero) );
        }
        this.formGroup.get(minutosTareaFormControl).setValue( String(numero).padStart(Constantes.DOS, Constantes.CERO.toString()) );
    }

    considerarPausa() {
        if (this.esPausaConsiderada) {
            this.formGroup.get(inicioPausaFormControl).enable();
            this.formGroup.get(horasPausaFormControl).enable();
            this.formGroup.get(minutosPausaFormControl).enable();
            this.validarHoraPausa();
            return;
        }

        this.formGroup.get(inicioPausaFormControl).disable();
        this.formGroup.get(horasPausaFormControl).disable();
        this.formGroup.get(minutosPausaFormControl).disable();
    }

    validarHoraPausa() {
        if (this.formGroup.get(inicioPausaFormControl).value == null
            || this.utils.validarVacio(this.formGroup.get(inicioPausaFormControl).value)) {
            this.formGroup.get(inicioPausaFormControl).setErrors({ 'invalid': true });
            this.formGroup.get(inicioPausaFormControl).markAsTouched({ onlySelf: true });
            return;
        }

        const momentoPausa = this.obtenerMomentoPausa();

        if (momentoPausa <= new Date()) {
            this.formGroup.get(inicioPausaFormControl).setErrors({ 'invalid': true });
            this.formGroup.get(inicioPausaFormControl).markAsTouched({ onlySelf: true });
            return;
        }

        const horasPausar = Number(this.formGroup.get(horasPausaFormControl).value);
        momentoPausa.setHours(momentoPausa.getHours() + horasPausar);
        const minutosPausar = Number(this.formGroup.get(minutosPausaFormControl).value);
        momentoPausa.setMinutes(momentoPausa.getMinutes() + minutosPausar);

        if (momentoPausa.getDay() !== new Date().getDay()) {
            this.formGroup.get(inicioPausaFormControl).setErrors({ 'invalid': true });
            this.formGroup.get(inicioPausaFormControl).markAsTouched({ onlySelf: true });
            return;
        }

        this.formGroup.get(inicioPausaFormControl).setErrors(null);
    }

    agregarCerosInicialesMinutosPausa() {
        const numero: string = this.formGroup.get(minutosPausaFormControl).value;
        if (numero == null) { return; }
        this.validarHoraPausa();
        if (Number(numero) >= 10) {
            this.formGroup.get(minutosPausaFormControl).setValue( Number(numero) );
        }
        this.formGroup.get(minutosPausaFormControl).setValue( String(numero).padStart(Constantes.DOS, Constantes.CERO.toString()) );
    }

    public iniciarTareaLibremente() {
            this.dialogRef.close(Constantes.TAREA_SIN_PROGRAMAR);
    }

    public validarInicioTarea() {
        this.mapearProgramacionTarea();
        
        firstValueFrom(
            this.service.agregarElemento(UrlConstantes.VALIDAR_PROGRAMACION_TAREA, this.programacionTarea)
        ).then( response => {
            ;

            if (response.pCodRetorno !== Constantes.COD_EXITO) {
                swal.fire({
                    icon: 'warning',
                    text: response.pMensaje,
                    buttonsStyling: false,
                    customClass:{
                        confirmButton: 'btn btn-success',
                        cancelButton: 'btn btn-danger',
                      },
                    confirmButtonText: 'Aceptar',
                });
                return;
            }

            this.dialogRef.close(this.programacionTarea);

        }, error => {
            ;
            this.sweetAlert.showSwal('error-message', error);
        });
    }

    mapearProgramacionTarea() {
        this.programacionTarea.idUsuario = this.tarea.idUsuario;
        this.programacionTarea.idTarea = this.tarea.id;
        this.programacionTarea.duracionTarea = this.obtenerDuracionTarea();
        this.programacionTarea.inicioTarea = new Date();
        this.programacionTarea.esPausaConsiderada = this.esPausaConsiderada;
        this.programacionTarea.duracionPausa = this.obtenerDuracionPausa();
        this.programacionTarea.inicioPausa = this.obtenerMomentoPausa();
    }

    obtenerDuracionTarea(): number {
        const horasTarea = Number(this.formGroup.get(horasTareaFormControl).value)
            * Constantes.MIL * Constantes.SESENTA * Constantes.SESENTA;
        const minutosTarea = Number(this.formGroup.get(minutosTareaFormControl).value) * Constantes.MIL * Constantes.SESENTA;
        return minutosTarea + horasTarea;
    }

    obtenerMomentoPausa(): Date {
        const momentoPausa = new Date();
        const horaPausa = this.formGroup.get(inicioPausaFormControl).value.split(Constantes.DOS_PUNTOS)[Constantes.CERO];
        momentoPausa.setHours(horaPausa);
        const minutoPausa = this.formGroup.get(inicioPausaFormControl).value.split(Constantes.DOS_PUNTOS)[Constantes.UNO];
        momentoPausa.setMinutes(minutoPausa);
        return momentoPausa;
    }

    obtenerDuracionPausa(): number {
        const horasPausa = Number(this.formGroup.get(horasPausaFormControl).value)
            * Constantes.MIL * Constantes.SESENTA * Constantes.SESENTA;
        const minutosPausa = Number(this.formGroup.get(minutosPausaFormControl).value) * Constantes.MIL * Constantes.SESENTA;
        return minutosPausa + horasPausa;
    }

    cerrarModal() {
        this.dialogRef.close(null);
    }

}
